<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="localItems"
        :hide-default-header="empty"
        :height="localItems.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer
        dense
        item-key="string"
        style="white-space: nowrap"
    >
      <template v-slot:top>
        <v-toolbar
            flat
            dense
        >
          <v-toolbar-title>Groups</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>

      <template v-slot:body>
        <draggable
            v-model="localItems"
            handle=".drag-handle"
            tag="tbody"
            @change="onDragChange"
        >
          <tr
              v-for="(item, index) in localItems"
              :key="item.uid || item.id || index"
          >
            <td>{{ item.name }}</td>
            <td class="text-right">
              <v-icon @click.stop="row_update(item, index)" class="mr-2" small>mdi-pencil</v-icon>
              <v-icon class="mr-2 drag-handle" small>mdi-drag</v-icon>
              <v-icon @click.stop="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
            </td>
          </tr>
          </draggable>
      </template>
    </v-data-table>

    <c-group-dialog ref="dialog" />
  </div>
</template>

<script>
import VueTypes from "vue-types";
import { ViewRules } from "@/common/ViewRules";
import CGroupDialog from "@/modules/mconfigs/views/branch/c-group-dialog.vue";
import { GroupModel } from "@/modules/mconfigs/models/GroupModel";
import draggable from "vuedraggable";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";

export default {
  name: "c-group-table",
  components: { CGroupDialog, draggable },
  props: {
    items: VueTypes.arrayOf(GroupModel).isRequired,
    readonly: {
      type: VueTypes.Boolean,
      default: false
    }
  },
  data: () => ({
    headers: [
      { text: 'Name', sortable: true, value: 'name', class: "white blue--text", color: "red" },
      { text: "", value: "actions", width: "100%", sortable: false, align: "end" }
    ],
    localItems: [],
  }),
  computed: {
    empty() {
      return (this.localItems || []).length === 0;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit("update:items", this.localItems);
    },
    onDragChange() {
      this.emitUpdate();
    },
    row_create() {
      this.$refs.dialog
          .show(ViewRules.CREATE)
          .then((data) => {
            if (this.localItems.find(v => v.name.toLowerCase() === data.name.toLowerCase())) {
              this.$alert("Duplicate value!");
              return;
            }
            this.localItems.push(data);
            this.emitUpdate();
          })
          .catch(() => {});
    },
    row_update(item, index = null) {
      this.$refs.dialog
          .show(ViewRules.UPDATE, item.clone(), this.config)
          .then((data) => {
            if (this.localItems.find(v => v.name.toLowerCase() === data.name.toLowerCase() && v !== item)) {
              this.$alert("Duplicate value!");
              return;
            }
            const idx = typeof index === "number" ? index : this.localItems.indexOf(item);
            if (idx < 0) return;
            this.localItems.splice(idx, 1, data);
            this.emitUpdate();
          })
          .catch(() => {});
    },
    row_remove(item) {
      const configsCount = ConfigStoreUtils.getReleaseConfigs().filter(c => c.group?.toLowerCase() === item.name?.toLowerCase()).length;
      const message = configsCount > 0
          ? `Are you sure you want to remove this group? ${configsCount} config(s) will be moved to "No Branch".`
          : `Are you sure you want to remove this group?`;
      this.$confirm(message).then(() => {
        const index = this.localItems.indexOf(item);
        if (index >= 0) this.localItems.splice(index, 1);
        this.$notify("Group removed successfully.");
        this.emitUpdate();
      });
    },
  },
  watch: {
    items: {
      handler(newItems) {
        this.localItems = Array.isArray(newItems) ? newItems.slice() : [];
      },
      deep: true,
      immediate: true
    },
  },
};
</script>
